import { PotencyResult } from '../../types/recipe';

interface PotencySummaryProps {
  potencyResult: PotencyResult;
  servings: number;
}

export function PotencySummary({ potencyResult, servings }: PotencySummaryProps) {
  return (
    <div className="potency-summary">
      <h3>Potency Summary</h3>
      <div className="potency-totals">
        <p>
          <strong>Total Cannabinoids:</strong>{' '}
          {potencyResult.totalMg.toFixed(2)} mg
        </p>
        <p>
          <strong>Per Serving ({servings} {servings === 1 ? 'serving' : 'servings'}):</strong>{' '}
          {potencyResult.perServingMg.toFixed(2)} mg
        </p>
      </div>

      {potencyResult.byIngredient.length > 0 && (
        <div className="potency-breakdown">
          <h4>Per-Ingredient Breakdown</h4>
          <ul className="ingredient-potency-list">
            {potencyResult.byIngredient.map((item, index) => (
              <li key={index} className="ingredient-potency-item">
                <span className="ingredient-potency-name">{item.ingredientName}</span>
                <span className="ingredient-potency-type">{item.cannabinoidType}</span>
                <span className="ingredient-potency-mg">{item.mg.toFixed(2)} mg</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
